import { render } from "./PlaceInformation.vue?vue&type=template&id=c5f2c3fa"
import script from "./PlaceInformation.vue?vue&type=script&lang=js"
export * from "./PlaceInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SetUp/Location/PlaceInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c5f2c3fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c5f2c3fa', __exports__)) {
    api.reload('c5f2c3fa', __exports__)
  }
  
  module.hot.accept("./PlaceInformation.vue?vue&type=template&id=c5f2c3fa", () => {
    api.rerender('c5f2c3fa', render)
  })

}


export default __exports__